<template>
    <transition-group v-if="group"
        name="fade"
        :mode="mode"
        :duration="time" >
        <slot></slot>
    </transition-group>
    <transition :duration="time"
        name="fade"
        :mode="mode"
        v-else>
        <slot></slot>
    </transition>
</template>

<script lang="ts">
import Vue, { PropType, TransitionProps } from 'vue';

export default Vue.extend({
    props: {
        mode: String as PropType<TransitionProps['mode']>,
        group: Boolean,
        time: {
            type: Number,
            default: 0.3
        }
    },
    computed: {
        styles (): Record<string, string> {

            return {
                '--fade-time': `${this.time}s`
            };

        }
    }
});
</script>

<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity var(--fade-time) ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
